(function (ng) {
    ng.module('evo.returns.initiate.components', []);
    ng.module('evo.returns.initiate.services', []);
    ng.module('evo.Shared.Directives', []);
    ng.module('evo.Shared.Filters', []);
    var module = ng.module('evo.returns.initiate', ['ui.router', 'evo.Shared.Directives', 'evo.returns.initiate.components', 'evo.returns.initiate.services', 'evo.Shared.Filters']);

    module.config(['$stateProvider', '$locationProvider', 'RETURNS_BASE',
        function ($stateProvider, $locationProvider, RETURNS_BASE) {
            $stateProvider
                .state({
                    name: 'initiate',
                    component: 'initiateReturnRoot',
                    resolve: {
                        //initialize the objects that will be maintained by the state machine
                        //the true initial values are set in the component
                        createRequest: function () { return {}; },
                        createResponse: function () { return {}; },
                        findOrderModel: function () { return {}; },
                    }
                })
                .state({
                    name: 'initiate.initiateReturnPage',
                    component: 'initiateReturnPage',
                    url: RETURNS_BASE + 'initiate'
                })
                .state({
                    name: 'initiate.confirmRequestPage',
                    component: 'confirmRequestPage',
                    url: RETURNS_BASE + 'confirm'
                })
                .state({
                    name: 'initiate.returnAuthorizationSubmittedPage',
                    component: 'returnAuthorizationSubmittedPage',
                    url: RETURNS_BASE + 'complete'
                });

            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            });
        }
    ]);
    module.run(['$transitions',
        function ($transitions) {
            //fix scrolling issues
            $transitions.onSuccess({}, function (transition) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            });
        }]);
})(angular);